module.exports = __webpack_public_path__ + "media/images/icons/inbox-c8d4dccdeeebd8c518bf93976676765e.svg";